export const OTP = "OTP"; // for Login Screen
export const ENCRYPTION_KEY = "HealthInsuranceSystem"; // for Encryption
export const COMPANY_EMAIL_ID = "Company E-Mail ID"
export const APPROVAL_HIEARCHY_MASTER = "Approval Hiearchy Master"
export const ROLE_AUTHORIZATION_MASTER = "Role Authorization Master"
export const UNIT_CONVERSION_MASTER = "Unit Conversion Master"
export const USER_MASTER = "User Master"
export const LOCATION_MASTER = "Location Master"
export const CUSTOMER_MASTER = "Customer Master"
export const COUNTRY_MASTER = "Currency Master"
export const MAIL_REMINDER = "Mail Reminder"
export const CREATE_NEW_SOLUTION = "Create New Solution"
export const DASHBOARD = "DashBoard"
export const REPORTS = "Reports"
export const ALL_SOLUTION_RECORDS = "All Solution Records"
export const PENDING_FOR_APPROVAL = "Solutions Pending For Approval"

export const START_YEAR = 2021

export const PASSWORD_VALIDATION = ["012", "123", "234", "345", "456", "567", "678", "789", "210", "321", "432", "543", "654", "765", "876", "987", "godrej", "jerdog"]
 
export const STATUS = ["Active", "Inactive"]
export const CONFIG_LEVEL = ["System", "Admin"]
export const STD = ["022","021"]
export const ISD = ["+91","+92"]

export const ROLE_CODE = ["Admin", "HR", "Emp", "SuperAdmin"]

export const SEQUENCE = [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
export const PAGINATION_COUNT= [10, 25, 50];

export const DOCUMENT_STATUS_OPTIONS = ["Pending", "Attached", "Not Applicable"];

export const DOCUMENT_FIELDS_CONFIG = {
    ISOB: { exclude: ["Not Applicable"] },
    DrawingApprovalMail: { exclude: ["Not Applicable"] },
    FinalDirectBookingBOM: { exclude: ["Not Applicable"] },
    LOICustConfirmation: { exclude: ["Not Applicable"] },
};
